"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _RestClient = _interopRequireDefault(require("./RestClient"));

var _onboarding = _interopRequireDefault(require("./client/onboarding"));

var _survey = _interopRequireDefault(require("./client/survey"));

var _user = _interopRequireDefault(require("./client/user"));

var _intention = _interopRequireDefault(require("./client/intention"));

var _selfReflection = _interopRequireDefault(require("./client/selfReflection"));

var _mediaLibrary = _interopRequireDefault(require("./client/mediaLibrary"));

var _programs = _interopRequireDefault(require("./client/programs"));

var _payment = _interopRequireDefault(require("./client/payment"));

var _session = _interopRequireDefault(require("./client/session"));

var _company = _interopRequireDefault(require("./client/company"));

var _document = _interopRequireDefault(require("./client/document"));

var _transformation = _interopRequireDefault(require("./client/transformation"));

var _journey = _interopRequireDefault(require("./client/journey"));

var _journal = _interopRequireDefault(require("./client/journal"));

var _coachingPlan = _interopRequireDefault(require("./client/coachingPlan"));

var _quests = _interopRequireDefault(require("./client/quests"));

var _custom = _interopRequireDefault(require("./client/custom360"));

var Client = /*#__PURE__*/(0, _createClass2["default"])(function Client() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck2["default"])(this, Client);
  var restClient = new _RestClient["default"]({
    baseUrl: options.baseUrl
  });
  this.onboarding = new _onboarding["default"](restClient);
  this.survey = new _survey["default"](restClient);
  this.user = new _user["default"](restClient);
  this.intention = new _intention["default"](restClient);
  this.selfReflection = new _selfReflection["default"](restClient);
  this.mediaLibrary = new _mediaLibrary["default"](restClient);
  this.programs = new _programs["default"](restClient);
  this.payment = new _payment["default"](restClient);
  this.session = new _session["default"](restClient);
  this.company = new _company["default"](restClient);
  this.userReport = new _document["default"](restClient);
  this.transformation = new _transformation["default"](restClient);
  this.journey = new _journey["default"](restClient);
  this.journal = new _journal["default"](restClient);
  this.coachingPlan = new _coachingPlan["default"](restClient);
  this.quests = new _quests["default"](restClient);
  this.custom360 = new _custom["default"](restClient);
});
exports["default"] = Client;